/**
 * CSRF client helpers for Artemis frontends.
 *
 * fetchCsrfToken  — fetch a fresh CSRF token from the server.
 * csrfHeaders     — produce the header object required on mutating requests.
 *
 * Both helpers are intentionally dependency-free (no axios, no lodash).
 * The token must never be logged; callers are responsible for treating it
 * as a short-lived secret.
 */
export async function fetchCsrfToken(baseUrl, fetchImpl = fetch) {
    const url = `${baseUrl}/auth/csrf-token`;
    const response = await fetchImpl(url, {
        method: 'GET',
        credentials: 'include',
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch CSRF token: HTTP ${response.status.toString()}`);
    }
    const body = await response.json();
    if (body === null ||
        typeof body !== 'object' ||
        !('csrfToken' in body) ||
        typeof body['csrfToken'] !== 'string') {
        throw new Error('Failed to fetch CSRF token: unexpected response shape (missing csrfToken string)');
    }
    return body.csrfToken;
}
export function csrfHeaders(token) {
    return { 'x-csrf-token': token };
}
//# sourceMappingURL=csrf.js.map